import React from "react";
import shortid from "shortid";
import useStyles from "@hooks/useStyles";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import ButtonBase from "@material-ui/core/ButtonBase";
import Box from "@material-ui/core/Box";

import Avatar from "@material-ui/core/Avatar";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";

const WebsiteLogoList = () => {
	const classes = useStyles("Website");

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const columns = "6"; // 1-6
	const columnsMobile = "3"; // 1-3
	const padding = 8; // 1-10
	const paddingMobile = padding / 2;

	const header = ``;
	const subHeader = ``;
	const tagline = "";
	const textAlign = "center"; // left / center / right
	const lineBreak = false;
	const content = "";

	const button = "";
	const buttonLink = "/wesbite/about-us";

	const buttonSecondary = "";
	const buttonSecondaryLink = "/wesbite/about-us";

	const video = false;

	const cards = [
		{
			youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",

			link: "/",
			image:
				"https://images.squarespace-cdn.com/content/v1/636a918eed06c30bfa498d2c/5687780e-dd59-4426-b1ca-98a129ba1736/best_of_zola_2024.png",
		},
		{
			youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
			link: "/",
			image:
				"https://images.squarespace-cdn.com/content/v1/636a918eed06c30bfa498d2c/a27e3ddf-32ef-4f13-869d-4512a0966fd8/anti-bride.jpeg",
		},
		{
			youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
			link: "/",
			image:
				"https://images.squarespace-cdn.com/content/v1/636a918eed06c30bfa498d2c/24f292e7-02c7-4aa4-8437-aae22a7acd27/2023-offbeat-wed-vendor-badge-pink.png",
		},
		{
			youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
			link: "/",
			image:
				"https://images.squarespace-cdn.com/content/v1/636a918eed06c30bfa498d2c/55541a19-bd41-4909-9673-5f6bbb67ba81/wed_society_austin_logo.jpeg",
		},
		{
			youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
			link: "/",
			image:
				"https://images.squarespace-cdn.com/content/v1/636a918eed06c30bfa498d2c/7a921f28-aa23-4145-8bdd-db41fd847c2b/Carats-Cake-transparent2.png",
		},
		{
			youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
			link: "/",
			image:
				"https://images.squarespace-cdn.com/content/v1/636a918eed06c30bfa498d2c/27b173ec-6eb7-4552-9a11-5096753d5aa5/2560px-Eater_logo.svg.png",
		},
		// {
		// 	youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
		// 	link: "/",
		// 	image:
		// 		"https://static.wixstatic.com/media/cde42c_ea87d880b3154a1f943ad5f5635322b4~mv2.jpg/v1/fill/w_756,h_192,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/procaresolutions-logo-2169961.jpg",
		// },
		// {
		// 	youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
		// 	link: "/",
		// 	image:
		// 		"https://static.wixstatic.com/media/cde42c_e91ced39ec9142fe9f997b014ca9451a~mv2.png/v1/fill/w_908,h_282,al_c,lg_1,q_85,enc_auto/ELEA-copy.png",
		// },
		// {
		// 	youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
		// 	link: "/",
		// 	image:
		// 		"https://static.wixstatic.com/media/cde42c_ea87d880b3154a1f943ad5f5635322b4~mv2.jpg/v1/fill/w_756,h_192,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/procaresolutions-logo-2169961.jpg",
		// },
		// {
		// 	youtubeEmbedUrl: "https://www.youtube.com/embed/L3gOf2XDp8Y",
		// 	link: "/",
		// 	image:
		// 		"https://static.wixstatic.com/media/cde42c_0461bb464c1a4f90b9424a7cd00dc5f4~mv2.png/v1/fill/w_646,h_282,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Texas%20Rising%20Star.png",
		// },
	];

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundlink: "/",
							image: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={10}
							justifyContent="center"
							alignItems={textAlign}
						>
							{(tagline || header || subHeader || lineBreak || content) && (
								<Grid item xs={12}>
									<Box
										display={"flex"}
										flexDirection={"column"}
										justifyContent={"center"}
										alignItems={textAlign}
										height={"100%"}
									>
										{tagline && (
											<Box className="tagline" textAlign={textAlign}>
												{tagline}
											</Box>
										)}

										{header && (
											<Box component={"h2"} textAlign={textAlign}>
												{header}
											</Box>
										)}

										{subHeader && (
											<Box component={"h3"} textAlign={textAlign}>
												{subHeader}
											</Box>
										)}

										{lineBreak && (
											<Box my={1} textAlign={textAlign}>
												<LineBreak className={classes.lineBreak} />
											</Box>
										)}

										{content && (
											<>
												<Box component={"p"} textAlign={textAlign}>
													{content}
												</Box>
											</>
										)}
									</Box>
								</Grid>
							)}

							<Grid item xs={12}>
								<Grid
									container
									spacing={isMobile ? 2 : 10}
									justifyContent="center"
									alignItems={"center"}
								>
									{cards.map((card) => (
										<Grid
											item
											xs={
												columnsMobile === "1"
													? 12
													: columnsMobile === "2"
													? 6
													: columnsMobile === "3"
													? 4
													: 3
											}
											md={
												columns === "1"
													? 12
													: columns === "2"
													? 6
													: columns === "3"
													? 4
													: columns === "4"
													? 3
													: columns === "5"
													? 2
													: 2
											}
											key={shortid.generate()}
										>
											<ButtonBase href={card.link}>
												{video ? (
													<>
														<div
															className="video-responsive"
															style={{
																position: "relative",
																paddingBottom: "56.25%",
																height: 0,
															}}
														>
															<iframe
																style={{
																	position: "absolute",
																	top: 0,
																	left: 0,
																	width: "100%",
																	height: "100%",
																}}
																src={card.youtubeEmbedUrl}
																frameBorder="0"
																allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
																allowFullScreen
																title="Embedded YouTube Video"
															/>
														</div>
													</>
												) : (
													<>
														<Box
															width={"100%"}
															height={"100%"}
															display={"flex"}
															position={"relative"}
															p={{ xs: paddingMobile, sm: padding }}
														>
															<Avatar
																variant="rounded"
																src={card.image}
																alt="pic"
																imgProps={{
																	decoding: "async",
																	loading: "lazy",
																}}
																className="pictureMediaCard borderRadius0"
															/>
														</Box>
													</>
												)}
											</ButtonBase>
										</Grid>
									))}
								</Grid>
							</Grid>

							{(button || buttonSecondary) && (
								<Grid item xs={12}>
									<Box
										className={classes.columnButtonsBox}
										textAlign={textAlign}
										justifyContent={textAlign}
										mt={"40px !important"}
									>
										{button && (
											<Button
												size="large"
												color="primary"
												variant="contained"
												disableElevation
												href={buttonLink}
												className="columnButton"
											>
												{button}
											</Button>
										)}

										{buttonSecondary && (
											<Button
												size="large"
												color="secondary"
												variant="outlined"
												disableElevation
												href={buttonSecondaryLink}
												className="columnButton"
											>
												{buttonSecondary}
											</Button>
										)}
									</Box>
								</Grid>
							)}
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteLogoList;
